(function(){

  // --- Free shipping progress bar (real store threshold: kostenloser Versand in DE ab 80,00 EUR) ---
  // Runs unconditionally (independent of prefers-reduced-motion below), since it's informational, not decorative.
  var SAT_FREESHIP_THRESHOLD_CENTS = 8000;
  var SAT_BUNDLE_MIN_QTY = 2;

  function satFormatMoney(cents){
    var value = (Math.round(cents) / 100).toFixed(2).replace('.', ',');
    return '€' + value;
  }

  function satRenderFreeShipBars(totalCents){
    var bars = document.querySelectorAll('[data-sat-freeship]');
    if (!bars.length) { return; }
    var pct = Math.max(0, Math.min(100, (totalCents / SAT_FREESHIP_THRESHOLD_CENTS) * 100));
    bars.forEach(function(el){
      var fill = el.querySelector('[data-sat-freeship-fill]');
      var text = el.querySelector('[data-sat-freeship-text]');
      if (fill) { fill.style.width = pct + '%'; }
      if (text) {
        if (totalCents >= SAT_FREESHIP_THRESHOLD_CENTS) {
          text.textContent = 'Gratisversand aktiv';
          el.classList.add('sat-freeship--done');
        } else {
          var remaining = SAT_FREESHIP_THRESHOLD_CENTS - totalCents;
          text.textContent = 'Noch ' + satFormatMoney(remaining) + ' bis Gratisversand';
          el.classList.remove('sat-freeship--done');
        }
      }
    });
  }

  function satRenderBundleBars(itemCount){
    var bars = document.querySelectorAll('[data-sat-bundle]');
    if (!bars.length) { return; }
    bars.forEach(function(el){
      var text = el.querySelector('[data-sat-bundle-text]');
      if (!text) { return; }
      var remaining = SAT_BUNDLE_MIN_QTY - itemCount;
      if (remaining <= 0) {
        text.textContent = '10% Rabatt aktiv';
        el.classList.add('sat-bundle--done');
      } else {
        text.textContent = 'Noch ' + remaining + ' ' + (remaining === 1 ? 'Teil' : 'Teile') + ' bis -10%';
        el.classList.remove('sat-bundle--done');
      }
    });
  }

  function satRenderTotals(cart){
    var totalsBlocks = document.querySelectorAll('[data-sat-totals]');
    if (!totalsBlocks.length) { return; }
    var originalTotal = (typeof cart.original_total_price === 'number') ? cart.original_total_price : cart.total_price;
    var totalDiscount = (typeof cart.total_discount === 'number') ? cart.total_discount : 0;
    var pct = 0;
    if (originalTotal > 0 && totalDiscount > 0) {
      pct = Math.round((totalDiscount * 100) / originalTotal);
    }
    totalsBlocks.forEach(function(block){
      var origEl = block.querySelector('[data-original-subtotal]');
      if (origEl) {
        var formatted = satFormatMoney(originalTotal);
        if (origEl.textContent !== formatted) { origEl.textContent = formatted; }
      }
      var discountsWrap = block.querySelector('[data-discounts]');
      if (discountsWrap) {
        var newHtml = '';
        if (totalDiscount > 0) {
          newHtml =
            '<div class="cart__discounts cart__item-sub cart__item-row">' +
              '<div>Rabatte</div>' +
              '<div class="cart__discount text-right">-' + pct + '% (-' + satFormatMoney(totalDiscount) + ')</div>' +
            '</div>';
        }
        if (discountsWrap.innerHTML.replace(/\s+/g, '') !== newHtml.replace(/\s+/g, '')) {
          discountsWrap.innerHTML = newHtml;
        }
      }
    });
  }

  // Only re-fetch/re-render after an actual cart mutation (add/change/update/clear).
  // The very first paint already has correct values from the server-rendered Liquid,
  // so we deliberately do NOT call this on initial page load — that redundant overwrite
  // was causing a visible flash/jump right after the page appeared.
  function satRefreshFreeShip(){
    if (!document.querySelector('[data-sat-freeship]') && !document.querySelector('[data-sat-bundle]') && !document.querySelector('[data-sat-totals]')) { return; }
    fetch('/cart.js', {credentials: 'same-origin'})
      .then(function(r){ return r.json(); })
      .then(function(cart){
        satRenderFreeShipBars(cart.total_price);
        satRenderBundleBars(cart.item_count);
        satRenderTotals(cart);
      })
      .catch(function(){});
  }

  function satInitFreeShip(){
    // Re-check whenever the theme's AJAX cart rewrites the subtotal / item list (add, change, remove)
    if ('MutationObserver' in window) {
      var satFreeShipTimer;
      var mo = new MutationObserver(function(){
        clearTimeout(satFreeShipTimer);
        satFreeShipTimer = setTimeout(satRefreshFreeShip, 150);
      });
      document.querySelectorAll('[data-subtotal], [data-products]').forEach(function(node){
        mo.observe(node, {childList: true, characterData: true, subtree: true});
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', satInitFreeShip);
  } else {
    satInitFreeShip();
  }

  // Belt & suspenders: also refresh right after any fetch call to the cart endpoints
  var satOrigFetch = window.fetch;
  if (satOrigFetch) {
    window.fetch = function(){
      var args = arguments;
      var target = args[0];
      var url = (target && target.url) ? target.url : target;
      var p = satOrigFetch.apply(this, args);
      if (typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
        p.then(function(){ setTimeout(satRefreshFreeShip, 250); }).catch(function(){});
      }
      return p;
    };
  }

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }

  // --- Eager-load hero slideshow images so slides never flash black on first autoplay transition ---
  function eagerLoadHeroImages(){
    document.querySelectorAll('.hero__image[data-src]').forEach(function(img){
      if (img.getAttribute('data-eager-done')) { return; }
      img.setAttribute('data-eager-done', '1');
      var full = img.getAttribute('data-src');
      if (full) {
        var src = full.replace('{width}', '1600');
        img.src = src;
        img.removeAttribute('data-sizes');
        img.classList.remove('lazyload');
        img.classList.add('lazyloaded');
      }
    });
  }
  eagerLoadHeroImages();
  document.addEventListener('DOMContentLoaded', eagerLoadHeroImages);

  document.addEventListener('DOMContentLoaded', function(){

    // --- Scroll reveal (only for elements the theme doesn't already animate itself) ---
    var revealSelectors = '.footer-promotions .grid__item, .rte';
    var items = document.querySelectorAll(revealSelectors);
    if ('IntersectionObserver' in window && items.length) {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if (entry.isIntersecting) {
            entry.target.classList.add('sat-reveal-visible');
            io.unobserve(entry.target);
          }
        });
      }, {threshold: 0.05, rootMargin: '0px 0px -40px 0px'});
      items.forEach(function(el, i){
        el.classList.add('sat-reveal');
        el.style.transitionDelay = (Math.min(i % 4, 3) * 0.08) + 's';
        io.observe(el);
      });

      // Safety net: never let content stay invisible if something goes wrong
      setTimeout(function(){
        items.forEach(function(el){ el.classList.add('sat-reveal-visible'); });
      }, 4000);
    }

    // --- Sticky add-to-cart bar (product pages) ---
    var addBtn = document.querySelector('[data-add-to-cart]');
    var productSection = document.querySelector('.product-section');
    if (addBtn && productSection) {
      var title = productSection.getAttribute('data-product-title') || '';
      var priceEl = document.querySelector('[data-product-price]');
      var price = priceEl ? priceEl.textContent.trim() : '';
      var btnLabel = addBtn.textContent.trim() || 'In den Warenkorb';

      var bar = document.createElement('div');
      bar.className = 'sat-sticky-bar';
      bar.innerHTML =
        '<div class="sat-sticky-bar__inner">' +
          '<span class="sat-sticky-bar__title">' + title + '</span>' +
          '<span class="sat-sticky-bar__price">' + price + '</span>' +
          '<button type="button" class="btn sat-sticky-bar__btn">' + btnLabel + '</button>' +
        '</div>';
      document.body.appendChild(bar);

      bar.querySelector('.sat-sticky-bar__btn').addEventListener('click', function(){
        if (!addBtn.disabled) { addBtn.click(); }
      });

      if ('IntersectionObserver' in window) {
        var barIo = new IntersectionObserver(function(entries){
          entries.forEach(function(entry){
            if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
              bar.classList.add('sat-sticky-bar--visible');
            } else {
              bar.classList.remove('sat-sticky-bar--visible');
            }
          });
        }, {threshold: 0});
        barIo.observe(addBtn);
      }
    }

    // --- Lookbook + Complete-the-look: mouse-drag horizontal scroll (touch already works natively) ---
    document.querySelectorAll('[data-sat-lookbook-scroller], [data-sat-drag-scroll]').forEach(function(scroller){
      var isDown = false, startX = 0, startScroll = 0, moved = false;
      scroller.addEventListener('pointerdown', function(e){
        if (e.pointerType === 'touch') { return; }
        isDown = true; moved = false;
        startX = e.clientX;
        startScroll = scroller.scrollLeft;
        scroller.classList.add('is-dragging');
      });
      window.addEventListener('pointermove', function(e){
        if (!isDown) { return; }
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4) { moved = true; }
        scroller.scrollLeft = startScroll - dx;
      });
      window.addEventListener('pointerup', function(){
        if (!isDown) { return; }
        isDown = false;
        scroller.classList.remove('is-dragging');
      });
      scroller.addEventListener('click', function(e){
        if (moved) { e.preventDefault(); e.stopPropagation(); }
      }, true);
      scroller.addEventListener('wheel', function(e){
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
          scroller.scrollLeft += e.deltaY;
          e.preventDefault();
        }
      }, {passive:false});
    });

    // --- Magnetic buttons + custom cursor (desktop / fine pointer only) ---
    if (window.matchMedia && window.matchMedia('(pointer:fine)').matches) {
      var cursor = document.createElement('div');
      cursor.className = 'sat-cursor';
      document.body.appendChild(cursor);
      var cx = 0, cy = 0, tx = 0, ty = 0;
      window.addEventListener('mousemove', function(e){
        tx = e.clientX; ty = e.clientY;
        cursor.classList.add('sat-cursor--active');
      });
      function raf(){
        cx += (tx - cx) * 0.18;
        cy += (ty - cy) * 0.18;
        cursor.style.transform = 'translate(' + cx + 'px,' + cy + 'px)';
        window.requestAnimationFrame(raf);
      }
      window.requestAnimationFrame(raf);

      var magnets = document.querySelectorAll('.btn, .sat-lookbook__item');
      magnets.forEach(function(el){
        el.addEventListener('mouseenter', function(){ cursor.classList.add('sat-cursor--hover'); });
        el.addEventListener('mouseleave', function(){
          cursor.classList.remove('sat-cursor--hover');
          el.style.transform = '';
        });
        if (el.classList.contains('btn')) {
          el.addEventListener('mousemove', function(e){
            var r = el.getBoundingClientRect();
            var mx = e.clientX - r.left - r.width / 2;
            var my = e.clientY - r.top - r.height / 2;
            el.style.transform = 'translate(' + (mx * 0.22) + 'px,' + (my * 0.22) + 'px)';
          });
        }
      });
    }
  });
})();
